<template lang="pug">
    div
        v-data-table(
            hide-default-footer 
            :headers="headers" 
            :items="listData" 
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            :page.sync="page"
        )
            template(v-slot:top="{item}")
                div(class="caption font-weight-bold primary white--text text-center justify-center") DAFTAR KWITANSI
            template(v-slot:item.status="{item}")
                v-chip(small v-if="item.status" :color="item.status == 'BERHASIL' ? 'info' : item.status == 'GAGAL' ? 'error' : 'warning'" dark) {{ item.status }}
            template(v-slot:item.transactionId="{item}")
                div(v-if="item.noArsip") {{ item.noArsip }}
            template(v-slot:item.kmg="{item}")
                div(v-if="item.additionalData && item.additionalData.gaji") {{ item.additionalData.gaji.kmgAmount | decimalformat }}
            template(v-slot:item.name="{item}")
                div(v-if="item.customerName") {{ item.customerName }}
            template(v-slot:item.bankCode="{item}")
                div(v-if="item.additionalData && item.additionalData.parameter && item.additionalData.parameter.bank") {{ item.additionalData.parameter.bank.bankId }}
            template(v-slot:item.productDetail="{item}")
                div(v-if="item.productCode") {{ item.productCode }}
            template(v-slot:item.denom="{item}")
                div(v-if="item.denomCode") {{ item.denomCode | decimalformat }}
            template(v-slot:item.amount="{item}")
                div {{ item.nilai | decimalformat }}
            template(v-slot:item.fee="{item}")
                div {{ item.biaya | decimalformat }}
            template(v-slot:item.total="{item}")
                div {{ item.total | decimalformat }}
            template(v-slot:item.errorMessage="{item}")
                div {{ item.errorMessage==null?item.keteranganError:item.errorMessage }}
            template(v-slot:item.action="{item}")
                v-layout(wrap justify-center class="menu-btn-sm")
                    v-btn(color="primary" @click="show(item)" class="ma-1" v-if="item.additionalData && !(item.additionalData.productCode.includes('PAYROLL') || item.additionalData.productCode.includes('GAJI') || item.additionalData.productCode == 'TRF_INT')") Detail
                        v-icon mdi-arrow-right-circle
        div(class="text-xs-center")
            v-pagination(v-model="page" :length="pageCount")
                                
</template>
<script>
export default {
    name: "FSiskeudesDetailTable",
    props: ["detail"],
    data() {
        return {
            headers: [
                {text: 'No Bukti', value: 'noBukti', sortable: false, width: "17%", class: "primary--text"},
                {text: 'Bank Tujuan', value: 'namaBankPenerima', sortable: false, width: "13%", class: "primary--text"},
                {text: 'No Rekening', value: 'customerId', sortable: false, width: "15%", class: "primary--text"},
                {text: 'Jenis', value: 'productCode', sortable: false, width: "5%", class: "primary--text"},
                {text: 'Nama', value: 'name', sortable: false, width: "20%", class: "primary--text"},
                {text: 'Nominal', align: "right", value: 'amount', sortable: false, width: "10%", class: "primary--text"},
                {text: '', value: 'status', sortable: false, align: "center", width: "5%", class: "primary--text"},
                {text: 'Pesan', value: 'errorMessage', sortable: false, width: "15%", class: "primary--text"},
                //{text: '', value: 'action', sortable: false, width: "150px"},
            ],
            listData: [],
            itemsPerPage: 5,
            criteria: "",
            pageCount: 0,
            page: 1,
            item: null,
            productId: "",
            productGroup: "",
            content: null,
            data: null,
            transaction: null,
            step: "1",
        }
    },
    mounted() {
        this.doInit(this.detail);
    },
    watch: {
        detail(val) {
            this.doInit(val);
        }
    },
    computed: {
        amountDetail() {
            if (this.listData && this.listData.length > 0) {
                return this.listData.map(m => m.nilai).reduce((a,b) => a + b)
            } else {
                return 0;
            }
        },
        feeDetail() {
            if (this.listData && this.listData.length > 0) {
                return this.listData.map(m => m.biaya).reduce((a,b) => a + b)
            } else {
                return 0;
            }
        },
        totalDetail() {
            if (this.listData && this.listData.length > 0) {
                return this.listData.map(m => m.total).reduce((a,b) => a + b)
            } else {
                return 0;
            }
        }
    },
    methods: {
        doInit(value){
            this.step = "1";
            this.listData = value ? value.listDetail : [];
        },
        doReset(){
            this.itemsPerPage = 10;
            this.criteria = "";
            this.pageCount = 0;
            this.page = 1;
        },
        show(item){
            this.$emit("detail", item);
            this.item = item;
            if (this.item.additionalData) {
                this.productId = this.item.additionalData.productCode;
                this.productGroup = this.item.additionalData.productGroup;
                this.content = this.item.inquiryResponse;
                this.data = this.item.inquiryRequest;
                this.transaction = this.item.transactionResponse
            }
            this.step = "2";
        },
    },
}
</script>